export default function InitialLoader() {
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-white">
      <img
        src="/trueadviso_loading.gif"
        alt="Loading..."
        className="w-56 h-56 object-contain"
      />
    </div>
  );
}